module.exports = __webpack_public_path__ + "static/media/abt-1.453d4941.png";